export default __webpack_public_path__ + "static/media/complete-client-application-with-arrow.f356aab1.png";